import { useState } from "react";
import "../../styles/driver_modal.css";

export default function DriverDocumentUploadModal({
  open,
  onClose,
  onSubmit,
  docType,
}) {
  const [files, setFiles] = useState([]);

  if (!open) return null;

  function handleChange(e) {
    setFiles([...e.target.files]);
  }

  const isMultiple = docType?.isMultiple;

function handleSubmit(e) {
  e.preventDefault();

  if (!files.length) {
    alert("Veuillez sélectionner au moins un fichier");
    return;
  }

  const formData = new FormData();
  formData.append("id_driver", docType.driverId);
  formData.append("id_document", docType.id);

  files.forEach((file) => {
    formData.append("value[]", file);
  });

  onSubmit(formData);
}

  return (
    
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Uploader : {docType.name}</h3>

        <form onSubmit={handleSubmit} className="modalForm">
          <input
            type="file"
            multiple={docType.isMultiple}
            onChange={handleChange}
          />

          <div className="modalActions">
            <button className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btnPrimary">Uploader</button>
          </div>
        </form>
      </div>
    </div>
  );
}